/**
 * Deploy-stamp formatter (DNKADM-0376). Pure: no `window`, no env, no Vite.
 * A SHA-backed Vite build compiles `YYYYMMDD.<sha7>` from the build machine's
 * local calendar date plus the first seven characters of `GITHUB_SHA`.
 */
export function formatDeployStamp(now: Date, sha: string): string {
  const y = now.getFullYear();
  const m = String(now.getMonth() + 1).padStart(2, '0');
  const d = String(now.getDate()).padStart(2, '0');
  const short = sha.trim().slice(0, 7);
  return `${y}${m}${d}.${short}`;
}

/**
 * The calendar date a deploy stamp was built on (DNKADM-0382 U1), read back from the
 * stamp's own `YYYYMMDD.` prefix — the ONLY source the identifier carries. Returns a
 * local-calendar `Date` at midnight, or `null` for anything that is not a real
 * `YYYYMMDD.<rest>` stamp: a `local-<ISO>` hand build, an impossible month/day, or an
 * empty string. Never invents a time (the stamp carries none) and never guesses.
 */
export function parseDeployStampDate(stamp: string): Date | null {
  const match = /^(\d{4})(\d{2})(\d{2})\./.exec(stamp.trim());
  if (match === null) return null;
  const year = Number(match[1]);
  const month = Number(match[2]);
  const day = Number(match[3]);
  const date = new Date(year, month - 1, day);
  // `new Date(2026, 1, 31)` silently rolls into March; reject anything that moved.
  if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) {
    return null;
  }
  return date;
}
